import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client";

export default function GremienDashboard() {
  const [daten, setDaten] = useState(null);

  useEffect(() => {
    api.getMeinDashboard().then(setDaten).catch(() => {});
  }, []);

  if (!daten) return null;

  const kachel = (titel, wert, hinweis) => (
    <div className="card" style={{ padding: 20, flex: 1, minWidth: 160 }}>
      <div style={{ fontSize: 28, fontWeight: 700 }}>{wert}</div>
      <div style={{ fontSize: 13, color: "#666", marginTop: 4 }}>{titel}</div>
      {hinweis && <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>{hinweis}</div>}
    </div>
  );

  return (
    <div style={{ padding: 24 }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 20 }}>Mein Dashboard</h1>

      {daten.naechste_sitzung && (
        <div className="card" style={{ padding: 20, marginBottom: 20 }}>
          <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>Nächste Sitzung</div>
          <div style={{ fontSize: 18, fontWeight: 600 }}>{daten.naechste_sitzung.titel}</div>
          <div style={{ fontSize: 13, color: "#666" }}>
            {daten.naechste_sitzung.datum && new Date(daten.naechste_sitzung.datum).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" })}
          </div>
          <Link to={`/sitzungen/${daten.naechste_sitzung.id}`}>
            <button className="btn btn-primary" style={{ marginTop: 12 }}>Sitzung öffnen</button>
          </Link>
        </div>
      )}

      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        {kachel("Offene Mitzeichnungen", daten.offene_mitzeichnungen)}
        {kachel("Meine offenen Beschlüsse", daten.offene_beschluesse)}
        {kachel("Ungelesene Benachrichtigungen", daten.ungelesene_benachrichtigungen)}
      </div>
    </div>
  );
}
